// Per-content page metadata for shared links.
//
// The share pages served only the site-wide default tags, so a shared link
// previewed as just a name over "pixleyai.com". iMessage's link previewer
// executes JS, so setting these at load time upgrades the card most of our
// recipients actually see. (Crawlers that skip JS — WhatsApp, Facebook —
// still get the static defaults; fixing those needs prerendering.)
const upsert = (attr, key, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

export function setShareMeta({ title, description, image }) {
  if (title) {
    document.title = title;
    upsert('property', 'og:title', title);
    upsert('name', 'twitter:title', title);
  }
  if (description) {
    upsert('name', 'description', description);
    upsert('property', 'og:description', description);
    upsert('name', 'twitter:description', description);
  }
  if (image) {
    upsert('property', 'og:image', image);
    upsert('name', 'twitter:image', image);
  }
  upsert('property', 'og:url', window.location.href);
}
